import { ROUTES } from "config/routes";
import { ICONS_LABEL } from "shared/constants/icons";

const manager = [
  {
    name: "Administrador de Archivos",
    submenu: [
      {
        name: "Mis Videos",
        url: ROUTES.VIDEOS,
        icon: ICONS_LABEL.CloudDoneOutlined,
      },
      {
        name: "Mis Archivos",
        url: ROUTES.FILES,
        icon: ICONS_LABEL.AttachFileOutlined,
      },
      {
        name: "Informes",
        url: ROUTES.REPORTS,
        icon: ICONS_LABEL.AssessmentOutlined,
      },
      {
        name: "Descargas",
        url: ROUTES.DOWNLOADS,
        icon: ICONS_LABEL.CloudDownloadOutlined,
      },
      {
        name: "Registros",
        url: ROUTES.DOWNLOADS_LOGS,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
      {
        name: "Navegación por carpetas",
        url: ROUTES.FOLDER_NAVIGATION,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
    ],
  },
  {
    name: "Administrativo",
    url: null,
    icon: ICONS_LABEL.AdminPanelSettings,
    submenu: [
      {
        name: "Accesos",
        url: ROUTES.ACCESS_LOGS,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
    ],
  },
];

export default manager;
